

import React from 'react';
import VideoPreviewComponent from '../components/VideoPreview';
import { UploaderConsumer } from '../../../../Uploader';









const VideoPreviewContainer = (props) =>
<UploaderConsumer>
    {({ subscribeToAssetTranscoded }) =>
  <VideoPreviewComponent
    {...props}
    subscribeToAssetTranscoded={subscribeToAssetTranscoded} />}


  </UploaderConsumer>;


export default VideoPreviewContainer;